import { createSlice } from '@reduxjs/toolkit';

export const trackersSlice = createSlice({
  name: 'tracker',
  initialState: {},
  reducers: {},
});
export default trackersSlice.reducer;
